import { Document } from "../models/document";
import {v7 as uuidv7} from 'uuid'
import { linkTo } from "../navigation/navigation";

export function newDocument() {
  window.open(linkTo('#new-document'), '_blank');  
}

export function newWizard() {
  window.open(linkTo('#create'), '_blank');  
}

export function openInNewTab(docId: string) {
  window.open(linkTo('#' + docId), '_blank');  
}

export function navigate(props) {
  window.location.hash = constructHash(props);
}

export function constructHash({docId, paragraphId, commentId}) {
  return docId;
}

export function buildLink(props) {
  return linkTo('#' + constructHash(props))
}


export function newThread(activeDocument: Document) {
  activeDocument.activeThreadId = uuidv7()
}